import { Routes, Route } from "react-router-dom";
import { appRoutes } from "../menu";

const ContentRoutes = () =>{
  return (
    <Routes>
      {
        appRoutes.map(({path, element: Element}) => (
          <Route key={path} path={path} element={<Element />} />
        ))
      }
    </Routes>
  );
}

export default ContentRoutes;